import React, { useState, useEffect } from "react";
import axios from "axios";
import { ReactSession } from "react-client-session";
import "./BaaHam_NormalUsers_Password.css";
import Alert from "../../../Alert/Alert";

function BaaHam_NormalUsers_Password() {
    let Alerts = ["این میتواند ارور اول باشد که نمایان میشود", "ارور دوم در اینجا به نمایش در می آید", "سومین نکته میتواند اینجا به کاربر نمایش داده شود"];
    ReactSession.setStoreType("localStorage");
    const UserId = ReactSession.get("UserId");
    const [userData, setUserData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: null,
        password: "",
        isDeleted: false,
        type: "producerUser",
        active: true,
        createdAt: "",
        updatedAt: "",
        id: "",
    });

    useEffect(() => {
        if (UserId) {
            axios
                .get("https://hammaskan.ir:8443/api/users/" + UserId, {
                    params: {},
                })
                .then((res) => {
                    // console.log(res.data.data);
                    setUserData(res.data.data);
                })
                .catch((error) => {
                    // console.log(error);
                    window.location.href = "./Account";
                });
        } else {
            window.location.href = "./Account";
        }
    }, []);

    const updateUserPassword = () => {
        var labelLSGNDialogWait = document.getElementById("labelLSGNDialogWait");
        var loginDialogOk = document.getElementById("labelLSGNDialogOk");
        var loginDialogErr = document.getElementById("labelLSGNDialogErr");

        labelLSGNDialogWait.style.display = "inline-block";
        loginDialogOk.style.display = "none";
        loginDialogErr.style.display = "none";

        if (document.getElementById("userChangePassword") && document.getElementById("userChangeRePassword")) {
            var userChangePassword = document.getElementById("userChangePassword").value;
            var userChangeRePassword = document.getElementById("userChangeRePassword").value;
            if(userChangePassword && userChangeRePassword){
                if(userChangePassword === userChangeRePassword){
                    var params = {
                        password: userChangePassword,
                    };
                    axios
                        .put("https://hammaskan.ir:8443/api/users/" + UserId, params)
                        .then((res) => {
                            labelLSGNDialogWait.style.display = "none";
                            loginDialogOk.style.display = "inline-block";
                            loginDialogErr.style.display = "none";
                            
                            // console.log(res);
                        })
                        .catch((error) => {
                            console.log(error);
                            labelLSGNDialogWait.style.display = "none";
                            loginDialogOk.style.display = "none";
                            loginDialogErr.style.display = "inline-block";
                            if (error.response.data.message) {
                                loginDialogErr.textContent = error.response.data.message;
                            } else {
                                loginDialogErr.textContent = "مشکلی در بروز رسانی پسورد کاربران وجود دارد لطفا با پشتیبانی تماس بگیرید";
                            }
                        });
                } else {
                    labelLSGNDialogWait.style.display = "none";
                    loginDialogOk.style.display = "none";
                    loginDialogErr.style.display = "inline-block";
                    loginDialogErr.textContent = "لطفا پسورد خود را یکسان وارد نمایید";
                }
             
            } else {
                labelLSGNDialogWait.style.display = "none";
                loginDialogOk.style.display = "none";
                loginDialogErr.style.display = "inline-block";
                loginDialogErr.textContent = "لطفا پسورد جدید خود را وارد نمایید";
            }

        }
    };

    return (
        <div className="BaaHam_NormalUsers_Profile">
            {/* <Alert Alerts={Alerts} />
            <Alert Alerts={Alerts} color="Orange" />
            <Alert Alerts={Alerts} color="Red" /> */}
            <div className="BaaHam_NU_ProfileInputsContainer">
                <div className="BaaHam_NU_ProfileInputContainer">
                    <span className="BaaHam_NU_ProfileInputTitle">
                        رمزعبور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="InputExactContainerForBack">
                        <input className="BaaHam_NU_ProfileInput" id="userChangePassword" type="text" />
                    </div>
                </div>
                <div className="BaaHam_NU_ProfileInputContainer">
                    <span className="BaaHam_NU_ProfileInputTitle">
                        تکرار رمزعبور <span className="BaaHam_NU_ProfileInputTitleStar">*</span>
                    </span>
                    <div className="InputExactContainerForBack">
                        <input className="BaaHam_NU_ProfileInput" id="userChangeRePassword" type="text" />
                    </div>
                </div>
                
            </div>
            <div className="labelLSGN" id="labelLSGNDialogWait" style={{ display: "none", fontSize: "14px", backgroundColor: "#1B9CFC", color: "snow", width: "85%", padding: "12px 8px", borderRadius: "6px" }}>
                لطفا کمی صبر کنید ...
            </div>
            <div className="labelLSGN" id="labelLSGNDialogOk" style={{ display: "none", fontSize: "14px", backgroundColor: "#06d6a0", color: "snow", width: "96%", padding: "12px 8px", borderRadius: "6px", margin: "12px 0" }}>
                پسورد شما با موفقیت به روزرسانی شد
            </div>
            <div className="labelLSGN" id="labelLSGNDialogErr" style={{ display: "none", fontSize: "14px", backgroundColor: "tomato", color: "snow", width: "96%", padding: "12px 8px", borderRadius: "6px", margin: "12px 0" }}>
                --
            </div>
            <div className="BaaHam_NU_ProfileButtonContainer">
                <div className="BaaHam_NU_ProfileButton" onClick={updateUserPassword}>
                    <span>به روزرسانی</span>
                </div>
            </div>
        </div>
    );
}

export default BaaHam_NormalUsers_Password;
